import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export function CollapsibleRow({ avatar, title, meta, trailing, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const hasDetail = Boolean(children);

  return (
    <li className={`ops-list-item ops-list-item--collapsible ${open ? "is-open" : ""}`}>
      <div className="ops-list-item-row" onClick={() => hasDetail && setOpen(!open)} role={hasDetail ? "button" : undefined} tabIndex={hasDetail ? 0 : undefined}>
        {avatar && <div className="ops-list-item-avatar">{avatar}</div>}
        <div className="ops-list-item-body">
          <p className="ops-list-item-title">{title}</p>
          {meta && <p className="ops-list-item-meta">{meta}</p>}
        </div>
        <div className="ops-list-item-trailing" onClick={(e) => e.stopPropagation()}>
          {trailing}
          {hasDetail && (
            <button type="button" className="ops-list-item-toggle" onClick={() => setOpen(!open)} aria-label={open ? "Collapse details" : "Expand details"}>
              {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
          )}
        </div>
      </div>
      {hasDetail && open && <div className="ops-list-item-expand">{children}</div>}
    </li>
  );
}
